// extracted by mini-css-extract-plugin
export default {"counterParent":"CountDownWithMinutes_counterParent__bM3AW"};